import axios from 'axios';
import { API_URL } from 'utils/http';
import {
  CmcSizesResponse,
  CmcSizeUpdateBody,
  CmcSizeUpdateResponse,
  CmcSizesForInstanceResponse,
} from 'types/cmc';

export async function getCmcSizes({ page = 1 }: { page?: number } = {}) {
  try {
    const res = await axios.get<CmcSizesResponse>(
      `${API_URL}/cmc/getcmcsizes?page=${page}`,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
}

export async function updateCmcSizes(cmcSizesData: CmcSizeUpdateBody[]) {
  try {
    const res = await axios.post<CmcSizeUpdateResponse>(
      `${API_URL}/cmc/updatecmcsize`,
      {
        cmcSizes: cmcSizesData,
      },
    );
    return res.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}
export async function getCmcSizesForInstance({
  instanceID,
}: {
  instanceID: string;
}) {
  try {
    const res = await axios.get<CmcSizesForInstanceResponse>(
      `${API_URL}/cmc/getcmcsizes/instance?instanceID=${instanceID}&includeAll=true`,
    );
    return res.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || error.message);
  }
}
